import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import App from './App.jsx'
import MotionProvider from './components/MotionProvider.jsx'
import './index.css'

// Cada língua é um build estático servido num sub-caminho (/, /en/, /uk/, …).
// O Vite define BASE_URL a partir de `--base=/en/` (ver scripts/build-locales.mjs);
// o router precisa do mesmo prefixo como basename, senão /ar/ cai na rota «*»
// e a página renderiza o 404. React Router não quer barra final.
const BASENAME = import.meta.env.BASE_URL.replace(/\/$/, '')
// Fixa a língua do build (VITE_LOCALE) antes de renderizar — ver src/i18n.js.
import './i18n'

/* O title/description/og do index.html são fallback para quem não executa JS
   (crawlers de redes sociais). Como cada rota declara os seus e o React 19
   iça-os para o <head>, ficariam dois de cada — e um crawler lê o primeiro.
   Removem-se aqui, antes do primeiro render. */
document.querySelectorAll('head [data-fallback]').forEach((el) => el.remove())

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <MotionProvider>
            <BrowserRouter basename={BASENAME}>
                <App />
            </BrowserRouter>
        </MotionProvider>
    </React.StrictMode>,
)
